
function isNativeCryptoSupported() {
    // is browser
    if (!global.window) return false;
    if (!window?.crypto?.subtle) return false;
    if (typeof window.crypto.getRandomValues !== "function") return false;

    const { decrypt, encrypt, importKey } = window.crypto.subtle;
    return typeof decrypt === "function" && typeof encrypt === "function" && typeof importKey === "function";
}

async function getCryptoKey(password: string) {
    // key data has to be 16 or 32 bytes!
    let passwordData = new TextEncoder().encode(password);
    if (passwordData.length > 32)
        passwordData = passwordData.slice(0, 32);
    if (passwordData.length < 32)
        passwordData = new Uint8Array([...passwordData, ...new Uint8Array(32 - passwordData.length)])

    return await window.crypto.subtle.importKey(
        "raw",
        passwordData,
        { name: "AES-GCM" },
        false,
        ["encrypt", "decrypt"]
    );
}

export async function encrypt(value: string, password: string) {
    if (!isNativeCryptoSupported())
        return value;

    const data = new TextEncoder().encode(value);
    const key = await getCryptoKey(password);

    // for every encrypt different
    const iv = window.crypto.getRandomValues(new Uint8Array(12));

    const buffer = await window.crypto.subtle.encrypt({ name: "AES-GCM", length: 256, iv }, key, data);
    const array = new Uint8Array(buffer);

    // Combine IV and data
    const comboBuffer = new Uint8Array(iv.length + array.length);
    comboBuffer.set(iv);
    comboBuffer.set(array, iv.length);

    // Move to base64
    return btoa(String.fromCharCode(...comboBuffer));
}

export async function decrypt(value: string, password: string) {
    if (!isNativeCryptoSupported())
        return value;

    const stringArray = atob(value).split("").map((char) => char.charCodeAt(0));
    const comboArray = new Uint8Array(stringArray);

    const iv = comboArray.slice(0, 12);
    const dataArray = comboArray.slice(12);

    const key = await getCryptoKey(password);
    const plaintextBuffer = await window.crypto.subtle.decrypt({ name: "AES-GCM", length: 256, iv }, key, dataArray);

    return new TextDecoder().decode(plaintextBuffer);
}